import { combineReducers } from 'redux'
import {
  SELECT_SUBREDDIT,
  INVALIDATE_SUBREDDIT,
  REQUEST_POSTS,
  RECEIVE_POSTS,

  SELECT_ASSESSMENT,
  INVALIDATE_ASSESSMENT,
  LOAD_ASSESSMENTS,
  RECEIVED_ASSESSMENTS,

  INIT_BREADCRUMB,
  ADD_BREADCRUMB,
  LOAD_ACTIVITIES,

  FORMAT_EMPLOYEE,

  SUMMARIZE_CPS
} from './actions'

import { INVALIDATE_ACTIVITY } from '../activities/actions'

export function activities(state = [], action) {
  switch (action.type) {
  case LOAD_ACTIVITIES:
    return action.activities
  default:
    return state
  }
}




export function selectedAssessment(state = '' , action) {
  switch (action.type) {
    case SELECT_ASSESSMENT:
      return Object.assign({},state,action.assessment)
     case SELECT_SUBREDDIT:
      return action.assessmentId
    case INVALIDATE_ASSESSMENT:
      return null
    default:
      return state
  }
}

export function assessments(state = { isFetching: false, didInvalidate: false, items: []}, action) {
  switch (action.type) {
    case LOAD_ASSESSMENTS:
      return Object.assign({}, state, { isFetching: true, items:[]}) 
    case RECEIVED_ASSESSMENTS:
      return Object.assign({}, state, { isFetching: false, didInvalidate: false, items: action.assessments} )
    default:
      return state
  }
}

export function summarizedCps(state = '' , action) {
  switch (action.type) {
    case SUMMARIZE_CPS:
      return Object.assign({},action.cps)
    default:
      return state
  }
}




export function breadcrumbs(state =[], action) {
  switch (action.type) {
    case INIT_BREADCRUMB:
      return action.breadcrumbs
    case ADD_BREADCRUMB:
      return [...state,action.breadcrumb]
    case INVALIDATE_ACTIVITY:
      const breadcrumbs = state ? state.map((breadcrumb, i) => Object.assign({},breadcrumb)) : []
      breadcrumbs.pop()
      return breadcrumbs
    case INVALIDATE_ASSESSMENT:
      return []
    default:
      return state
  } 
}


function posts(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_SUBREDDIT:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_POSTS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_POSTS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.posts,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function activitiesByAssessmentId(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_SUBREDDIT:
    case RECEIVE_POSTS:
    case REQUEST_POSTS:
      return Object.assign({}, state, {
        [action.assessmentId]: posts(state[action.assessmentId], action)
      })
    default:
      return state
  }
}


export function employeeById(state = {}, action) {
  switch (action.type) {
    case FORMAT_EMPLOYEE:
      return Object.assign({}, state, {
        [action.employee.id]: action.employee
      })
    default:
      return state
  }  
}

export function asyncMessage(state ='message',action) {
  switch (action.type) {
    case 'ASYNC_SUCCEED':
      return action.message
      case 'ASYNC_FAILED':
      return action.message
    default:
      return state
  }
}

const rootReducer = combineReducers({
  activitiesByAssessmentId,
  selectedAssessment
})

export default rootReducer

//-------------------PUBLIC SELECTORS------------------

export function getAssessmentsByEmployeeId(state) {
  const { assessments } = state
  return assessments.items.map(doc =>  ({ id: doc.id,  employee: doc.data() }) )
/*

  const { selectedAssessment, firestore } = state
  const assessments = firestore.ordered.assessmentsByRater
  return selectedAssessment 
          ? assessments.filter(assessment => selectedAssessment.employeeId === assessment.employee.id)
          : null

          */
}

export function getActivities(state) {
  const { selectedAssessment } = state
  
  if (!selectedAssessment) return null

  const promises = selectedAssessment.activities.map(snapshot => snapshot.ref.get().then(doc => doc.data()))
  Promise.all(promises)

}



// WEBPACK FOOTER //
// ./src/assessments/reducers.js